import React from "react";
import { cleanArtistName } from "../utils/formatters";

const RecordCard = ({ record, onClick }) => {
    const artistName = cleanArtistName(record.artist);
    const coverSrc =
        record.cover && (record.cover.startsWith("http://") || record.cover.startsWith("https://"))
            ? record.cover
            : `https://rjbogz.com/records/${record.cover}`;

    return (
        <div className="card" onClick={onClick}>
            <img
                src={coverSrc}
                alt={`${artistName} - ${record.album}`}
            />
            <p>{`${artistName} - ${record.album}`}</p>
        </div>
    );
};

export default RecordCard;
